import { render } from "./Auth.vue?vue&type=template&id=009356bd"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"
script.render = render

export default script